import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { InvoiceModel } from 'src/app/models/invoicing/invoice.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InvoiceCashReceiptCaptureTableModel } from 'src/app/models/tables/wallet/invoice-cash-receipt-capture-table.model';
import { InvoiceSelectionTableModel } from 'src/app/models/tables/wallet/invoice-selection-table.model';
import { InvoiceCashReceiptModel } from 'src/app/models/wallet/invoice-cash-receipt.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvoiceCashReceiptService {

  constructor(private _httpClient: HttpClient) { }

  createAsync(invoiceCashReceiptContract: InvoiceCashReceiptModel): Observable<InvoiceCashReceiptModel> {
    return this._httpClient.post<InvoiceCashReceiptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceipt.CreateAsync}`,
      invoiceCashReceiptContract);
  }

  createSomeAsync(invoiceIds: Array<number>, cashReceiptId: number): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceipt.CreateSomeAsync}/${cashReceiptId}`,
      invoiceIds);
  }

  deleteInvoiceCashReceipt(invoiceCashReceiptId: number): Observable<InvoiceCashReceiptModel> {
    return this._httpClient.delete<InvoiceCashReceiptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceipt.DeleteInvoiceCashReceipt}/${invoiceCashReceiptId}`);
  }

  deleteSomeInvoiceCashReceipt(invoiceCashReceiptIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceipt.DeleteSomeInvoiceCashReceipts}`,
      invoiceCashReceiptIds);
  }

  exportInvoiceCashReceiptsConsultation(isChargeAccount: boolean, filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceipt.ExportInvoiceCashReceiptsConsultation}/${isChargeAccount}`, filters, {
      params, responseType: 'blob',
    });
  }

  exportInvoiceCashReceiptDetailsConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean, cashReceiptId: number, isChargeAccount: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString()).set('cashReceiptId', cashReceiptId.toString()).set('isChargeAccount', isChargeAccount.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceipt.ExportInvoiceCashReceiptDetailsConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllInvoiceCashReceiptsWithPagination(isChargeAccount: boolean, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceipt.GetAllInvoiceCashReceiptsWithPaginationAsync}/${isChargeAccount}`,
      filters, { params: params }
    );
  }

  getColumnsForCaptureTable(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceipt.GetColumnsForCaptureTableAsync}`);
  }

  getColumnsForGeneralConsultation(isChargeAccount: boolean): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceipt.GetColumnsForGeneralConsultationAsync}/${isChargeAccount}`);
  }

  getColumnsForInvoiceSelection(isChargeAccount: boolean): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceipt.GetColumnsForInvoiceSelectionAsync}/${isChargeAccount}`);
  }

  getInvoiceCashReceiptById(invoiceCashReceiptId: number): Observable<InvoiceCashReceiptModel> {
    return this._httpClient.get<InvoiceCashReceiptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceipt.GetInvoiceCashReceiptById}/${invoiceCashReceiptId}`);
  }

  getInvoiceCashReceiptByKeys(cashReceiptId: number, invoiceId: number): Observable<InvoiceCashReceiptModel> {
    return this._httpClient.get<InvoiceCashReceiptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceipt.GetInvoiceCashReceiptByKeys}/${cashReceiptId}/${invoiceId}`);
  }

  getInvoiceCashReceiptsByCashReceiptId(cashReceiptId: number): Observable<Array<InvoiceCashReceiptModel>> {
    return this._httpClient.get<Array<InvoiceCashReceiptModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceipt.GetInvoiceCashReceiptsByCashReceiptId}/${cashReceiptId}`);
  }

  getInvoicesForCashReceipt(cashReceiptId: number): Observable<Array<InvoiceModel>> {
    return this._httpClient.get<Array<InvoiceModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceipt.GetInvoicesForCashReceipt}/${cashReceiptId}`);
  }

  getInvoiceCashsForCaptureTable(page: number, limit: number, columnSort: string | null, ascendant: boolean, cashReceiptId: number, isChargeAccount: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<InvoiceCashReceiptCaptureTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '')
      .set('ascendant', ascendant).set('cashReceiptId', cashReceiptId).set('isChargeAccount', isChargeAccount);

    return this._httpClient.post<PagedResponseModel<InvoiceCashReceiptCaptureTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceipt.GetInvoiceCashsForCaptureTable}`,
      filters, { params: params }
    );
  }

  getListInvoicesForSelection(cashReceiptId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<InvoiceSelectionTableModel>> {
    const params = new HttpParams().set('cashReceiptId', cashReceiptId).set('page', page).set('limit', limit)
      .set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<InvoiceSelectionTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceipt.GetListInvoicesForSelectionAsync}`,
      filters, { params: params }
    );
  }

  updateInvoiceCashReceipt(invoiceCashReceiptContract: InvoiceCashReceiptModel): Observable<Array<InvoiceCashReceiptModel>> {
    return this._httpClient.put<Array<InvoiceCashReceiptModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceipt.UpdateInvoiceCashReceipt}`,
      invoiceCashReceiptContract);
  }

}
